export enum PaymentStatus {
  Pending = 1, // Pendiente (por defecto)
  InProcess = 2, // En proceso
  Approved = 3, // Aprobado
  Rejected = 4 // Rechazado
}

export const PaymentStatusNames: Record<PaymentStatus, string> = {
  [PaymentStatus.Pending]: "Pendiente",
  [PaymentStatus.InProcess]: "En proceso",
  [PaymentStatus.Approved]: "Aprobado",
  [PaymentStatus.Rejected]: "Rechazado"
};

export const getPaymentStatusName = (
  status: PaymentStatus | null | undefined
): string => {
  if (!status) return PaymentStatusNames[PaymentStatus.Pending];
  return (
    PaymentStatusNames[status] || PaymentStatusNames[PaymentStatus.Pending]
  );
};

export const getPaymentStatusClass = (
  status: PaymentStatus | null | undefined
): string => {
  switch (status) {
    case PaymentStatus.Approved:
      return "badge badge-success";
    case PaymentStatus.InProcess:
      return "badge badge-warning";
    case PaymentStatus.Rejected:
      return "badge badge-danger";
    case PaymentStatus.Pending:
    default:
      return "badge badge-secondary";
  }
};
